import React from 'react';
import { getEventsForYear } from '../data/events';

const TournamentRules = ({ prices, eventNames, eventVisibility, year }) => {
  const events = getEventsForYear(year || new Date().getFullYear()).filter(e => eventVisibility?.[e.id] !== false);

  const notes = [
    {
      num: "01",
      text: "This tournament is open to all amateur players."
    },
    {
      num: "02",
      text: "Only registered players of TTAB for the year 2026 can participate in the tournament."
    },
    {
      num: "03",
      text: "The names of only those players who have paid entry fees and made an application in the prescribed form will be accepted. Entry fees are non-refundable."
    },
    {
      num: "04",
      text: "All players must wear uniforms and proper sports shoes during practice and matches. The players will not be allowed to participate in the tournament if this rule is not observed/followed. (Pl. note we have to preserve synthetic flooring & maintain decorum)."
    },
    {
      num: "05",
      text: "The Tournament Committee reserves the right to refuse any entry without providing any reason."
    },
    {
      num: "06",
      text: "Original Birth Certificates must be produced for the events of Junior, Sub Junior, Cadet and Hopes. Without a Birth Certificate players will not be allowed to participate in this tournament."
    },
    {
      num: "07",
      text: "The tournament shall commence at 14:30 hours on 26th June 2026 with the following events: Hopes Under-9 Boys, Hopes Under-11 Boys, Cadet Under-13 Boys, and Sub-Junior Under-15 Boys, followed by Junior Under-17 Boys and Junior Under-19 Boys Singles events. The Men’s Singles event shall commence at 19:00 hours on the same day. The Women’s and Girls’ events shall commence on 27th June 2026 at 14:30 hours. All Veteran events shall commence on 28th June 2026 from 09:00 hours onwards."
    },
    {
      num: "08",
      text: "The tournament will be played as per the latest rules and regulations of ranking tournaments as adopted by the Gujarat State Table Tennis Association (GSTTA) & the Table Tennis Federation of India (TTFI). The decision of the Tournament Committee will be final and binding to all players."
    },
    {
      num: "09",
      text: "TTFI-approved balls will be used in the tournament."
    },
    {
      num: "10",
      text: "The Tournament Committee reserves the right to cancel any event, change the draw and timing of the matches if required."
    }
  ];

  return (
    <section id="rules" className="section rules">
      <div className="container">
        <h2 className="rules-fees-header">Tournament <span>Fees & Rules</span></h2>

        <div className="fees-card animate-fade-in">
          <h3>Entry Fees</h3>
          <div className="fees-list-container">
            <div className="fee-item highlight">
              <span className="fee-item-name" style={{ color: '#fff' }}>Registration Fee</span>
              <span className="fee-item-price">Rs. {prices?.REGISTRATION ?? 200}/-</span>
            </div>

            {events.map(event => (
              <div key={event.id} className="fee-item">
                <span className="fee-item-name">
                  {eventNames?.[event.id] || event.name}
                  {['md', 'mx'].includes(event.id) && <span className="entry-fee-tag">Entry Fee</span>}
                </span>
                <span className="fee-item-price">Rs. {event.id === 'only_register' ? (prices?.REGISTRATION ?? 200) : (prices?.[event.id] ?? 400)}/-</span>
              </div>
            ))}
          </div>
        </div>

        <div className="please-note-section animate-fade-in">
          <h2>Please Note</h2>
          <div className="note-grid">
            {notes.map(note => (
              <div key={note.num} className="note-card">
                <div className="note-number">{note.num}</div>
                <div className="note-text" dangerouslySetInnerHTML={{ __html: note.text.replace('non-refundable', '<strong>non-refundable</strong>').replace('final and binding', '<strong>final and binding</strong>').replace('Tournament Committee', '<strong>Tournament Committee</strong>') }}></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TournamentRules;
